// User-facing calendar days in Bricks' home time zone (America/Toronto), so a
// timestamp written at 8 PM ET reads as that day, not tomorrow (UTC), and a
// viewer elsewhere sees the same date the report was issued on.
export const HOME_TZ = 'America/Toronto';

const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: HOME_TZ, year: 'numeric', month: '2-digit', day: '2-digit' });

// 'YYYY-MM-DD' in Toronto for a Date or timestamp; a plain 'YYYY-MM-DD' is kept as is.
export function localDay(value = new Date()) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) return value.trim();
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return typeof value === 'string' ? value.slice(0, 10) : '';
  const p = Object.fromEntries(fmt.formatToParts(d).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}`;
}
